import React from 'react';
import { cn } from '@/lib/utils';

export const Button = React.forwardRef(({ className, variant = 'default', size = 'default', ...props }, ref) => {
  const variants = {
    default: 'bg-volt text-black hover:bg-volt-hover hover:-translate-y-px',
    outline: 'border border-white/20 text-white bg-transparent hover:border-volt hover:text-volt',
    ghost: 'bg-transparent text-white hover:bg-white/5',
    danger: 'bg-[#FF3B30] text-white hover:opacity-90',
    secondary: 'bg-white/10 text-white hover:bg-white/15',
  };
  const sizes = {
    sm: 'h-9 px-4 text-xs',
    default: 'h-11 px-6 text-sm',
    lg: 'h-14 px-8 text-base',
    icon: 'h-10 w-10',
  };
  return (
    <button
      ref={ref}
      className={cn(
        'inline-flex items-center justify-center gap-2 font-bold uppercase tracking-widest rounded-none transition-all duration-150 disabled:opacity-40 disabled:cursor-not-allowed',
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    />
  );
});
Button.displayName = 'Button';
